export const SHELL_PREFERENCE_STORAGE_KEY = "lufy.shellPreference";

export type ShellPreference = "mobile" | "desktop" | null;

const MOBILE_UA_PATTERN = /iPhone|iPod|Android.*Mobile|MicroMessenger|Mobile Safari/i;
const MOBILE_MAX_VIEWPORT = 768;

export function isMobileViewportDevice(userAgent: string, viewportWidth: number): boolean {
  return MOBILE_UA_PATTERN.test(userAgent) && viewportWidth < MOBILE_MAX_VIEWPORT;
}

const ADMIN_PATH = /^\/admin\/([^/]+)(\/.*)?$/;
const MOBILE_PATH = /^\/m\/([^/]+)(\/.*)?$/;

export function mobilePathForAdminPath(pathname: string): string | null {
  const match = ADMIN_PATH.exec(pathname);
  if (!match) return null;
  const slug = match[1];
  const rest = match[2] ?? "";
  if (rest === "" || rest === "/") return `/m/${slug}/studio`;
  if (rest === "/generation") return `/m/${slug}/studio`;
  if (rest === "/generation/video") return `/m/${slug}/studio/product_video`;
  if (rest === "/generation/material-renewal") return `/m/${slug}/studio/material-renewal`;
  if (rest === "/my-billing") return `/m/${slug}/me`;
  if (rest === "/products" || rest === "/products/new" || /^\/products\/[^/]+\/edit$/.test(rest)) return `/m/${slug}${rest}`;
  if (rest === "/tasks" || rest === "/outputs" || /^\/outputs\/[^/]+$/.test(rest)) return `/m/${slug}${rest}`;
  // 手机端 8 月补上了客户和线索(列表 + 详情);新建/编辑客户在桌面是弹层,不带网址。
  if (/^\/(?:customers|leads)(?:\/[^/]+)?$/.test(rest)) return `/m/${slug}${rest}`;
  if (/^\/customer-proposals(?:\/[^/]+)?$/.test(rest)) return `/m/${slug}${rest.replace("/customer-proposals", "/proposals")}`;
  if (rest === "/showcase") return `/m/${slug}/showcase`;
  return null;
}

export function desktopPathForMobilePath(pathname: string): string | null {
  const match = MOBILE_PATH.exec(pathname);
  if (!match) return null;
  const slug = match[1];
  const rest = match[2] ?? "";
  if (rest === "" || rest === "/") return `/admin/${slug}`;
  if (rest === "/studio") return `/admin/${slug}/generation`;
  if (rest === "/studio/product_video") return `/admin/${slug}/generation/video`;
  if (rest === "/studio/material-renewal") return `/admin/${slug}/generation/material-renewal`;
  if (rest.startsWith("/studio/")) return `/admin/${slug}/generation`;
  if (/^\/proposals(?:\/[^/]+)?$/.test(rest)) return `/admin/${slug}${rest.replace("/proposals", "/customer-proposals")}`;
  if (rest === "/me") return `/admin/${slug}/my-billing`;
  // 桌面没有单产品上架页——那是移动壳独有的形态。回退到桌面展厅列表,
  // 而不是让兜底分支拼出一个不存在的 /admin/{slug}/showcase/{productId}。
  if (rest.startsWith("/showcase/")) return `/admin/${slug}/showcase`;
  // 品类、风格管理在桌面上是产品列表页里的弹层，没有独立网址。
  if (rest === "/categories" || rest === "/styles") return `/admin/${slug}/products`;
  return `/admin/${slug}${rest}`;
}

export function resolveShellRedirect(input: {
  pathname: string;
  userAgent: string;
  viewportWidth: number;
  preference: ShellPreference;
}): string | null {
  const mobileDevice = isMobileViewportDevice(input.userAgent, input.viewportWidth);
  if (ADMIN_PATH.test(input.pathname)) {
    if (!mobileDevice || input.preference === "desktop") return null;
    return mobilePathForAdminPath(input.pathname);
  }
  if (MOBILE_PATH.test(input.pathname)) {
    if (mobileDevice || input.preference === "mobile") return null;
    return desktopPathForMobilePath(input.pathname);
  }
  return null;
}
